<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm7>
                <div class="form-group dropbox" v-if="!warehouse.imageUrl">
                  <button
                    v-if="warehouse.imageUrl"
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                  <input
                    type="file"
                    @change="onFileChanged"
                    class="input-file"
                  />
                  <p v-if="!warehouse.imageUrl">
                    Drag your file(s) here to begin
                    <br />or click to browse
                  </p>
                </div>
                <div v-if="warehouse.imageUrl">
                  <img :src="warehouse.imageUrl" width="600px" height="150px" />
                  <button
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                </div>
              </v-flex>
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="name"
                  label="Warehouse Name"
                  v-model="warehouse.name"
                  type="text"
                  :rules="rules.warehouseNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="code"
                  label="Warehouse Code"
                  v-model="warehouse.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="typeList"
                  label="Type"
                  v-model="warehouse.type"
                  item-text="label"
                  item-value="value"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-checkbox label="Back In Transfer" v-model="warehouse.backInTransfer"></v-checkbox>
              </v-flex>
              <v-flex sm12 v-if="warehouse.backInTransfer">
                <v-select
                  :items="warehouseList"
                  label="Return Warehouse"
                  v-model="warehouse.returnWarehouseId"
                  item-text="name"
                  item-value="id"
                  :rules="rules.returnWarehouseRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="location"
                  label="Warehouse Location"
                  v-model="warehouse.location"
                  type="text"
                  :rules="rules.locationRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Warehouse Description"
                  v-model="warehouse.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="warehouse.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="warehouse.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="warehouse.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="warehouse.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="warehouse.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="warehouse.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="warehouse.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addBin()">
                    Add Bin
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs1>Bin Name</v-flex>
                  <v-flex xs2>Bin Type</v-flex>
                  <v-flex xs2>Max Capacity</v-flex>
                  <v-flex xs2>Min Capacity</v-flex>
                  <v-flex xs2>Stock Balance</v-flex>
                  <v-flex xs2>SelfExpire</v-flex>
                </v-layout>
                <v-layout row wrap v-for="(bin, index) in warehouse.binList" :key="index">
                  <v-flex xs1>
                    <v-text-field
                      placeholder="Bin Name"
                      v-model="bin.name"
                      @click="showBins(), selectedIndex = index"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="bin.binType.typeName"
                      label="Bin Type"
                      :readonly="true"
                      :rules="rules.bintypeRules"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs2>
                    <v-text-field
                      placeholder="Max Capacity"
                      v-model="bin.maxCapacity"
                      type="number"
                      min="0"
                      :readonly="true"
                      :rules="rules.capacityRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      placeholder="Min Capacity"
                      v-model="bin.minCapacity"
                      type="number"
                      min="0"
                      :readonly="true"
                      :rules="rules.capacityRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      placeholder="Stock Balance"
                      v-model="bin.stockBalance"
                      type="number"
                      min="0"
                      :readonly="true"
                       :rules="rules.stockBalanceRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm2>
                    <v-menu
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="true"
                    >
                      <v-text-field
                        slot="activator"
                        label="Self Expire Date"
                        type="text"
                        prepend-icon="event"
                        v-model="bin.selfExpireDate"
                        readonly
                        :rules="rules.selfExpireRules"
                      ></v-text-field>
                      <v-date-picker v-model="bin.selfExpireDate"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn icon @click="removeBin(index, bin.id)" :disabled="index == 0">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="user.roleName === 'PRODUCTION_MANAGER'" >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn 
                  color="primary" 
                  :loading="saveLoading" 
                  :disabled="!valid || user.roleName === 'PRODUCTION_MANAGER'" 
                  type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Bin list dialog -->
    <v-dialog v-model="showBinListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Bin List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="binList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setBin(props.item.name, selectedIndex), showBinListDialog = !showBinListDialog"
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.binType.typeName }}</td>
                  <td>{{ props.item.maxCapacity }}</td>
                  <td>{{ props.item.minCapacity }}</td>
                  <td>{{ props.item.stockBalance }}</td>
                  <td>{{ props.item.selfExpireInMilliSeconds | format-ms-date-time }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { warehouseService } from "../../services/warehouse-service";
import { binService } from "../../services/bin-service";
import { Warehouse, Bin } from "../../models/model";
import { WarehouseFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";

export default {
  name: "WarehouseDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Warehouse",
        disabled: false,
        to: "warehouses"
      },
      {
        text: "Warehouse Detail",
        disabled: true
      }
    ],
    typeList: [
      { label: "Ground", value: "GROUND" },
      { label: "Production", value: "PRODUCTION" },
      { label: "Mobile", value: "MOBILE" }
    ],
    showBinListDialog: false,
    headers: [
      { text: "Name", value: "name" },
      { text: "Bin Type", align: "left", value: "binType.typeName" },
      { text: "Max Capacity", value: "maxCapacity" },
      { text: "Min Capacity", value: "minCapacity" },
      { text: "Stock Balance", value: "stockBalance" },
      { text: "SelfExpire", value: "selfExpire" }
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0
    },
    totalRows: 0,
    queryParams: {
      name: "",
      status: "ACTIVE",
    },
    selectedIndex: 0,
    showListLoading: false,
    bin: new Bin(),
    warehouseList: [],
    binList: [],
    createdDate: "",
    updatedDate: "",
    warehouse: new Warehouse(),
    oldWarehouse: new Warehouse(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new WarehouseFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new warehouse
    } else {
      this.getWarehouseDetail(id);
    }
    this.getWarehousesByStatus();
    this.addBin();
    this.getBinList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getBinList();
    },
    addBin() {
      // deep copy
      this.bin = new Bin();
      let bin = JSON.parse(JSON.stringify(this.bin));
      this.warehouse.binList.push(bin);
    },

    setBin(name, index) {
      let bin = commonService.search("name", name, this.binList);
      bin.selfExpireDate = commonService.formatDate(
        new Date(bin.selfExpireInMilliSeconds).toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.warehouse.binList[index] = bin;
      console.log(this.warehouse.binList);
    },
    getBinList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return binService
        .getNoWarehouseBinList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.binList = res.data.binList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showBins() {
      // Clean query params
      this.queryParams.name = "";
      this.getBinList().then(
        (this.showBinListDialog = !this.showBinListDialog)
      );
    },

    removeBin(index, binId) {
      if (binId) {
        // add delete price Model Detail in id
        if (!this.warehouse.deleteBinIds) {
          this.warehouse.deleteBinIds = [];
        }
        this.warehouse.deleteBinIds.push(binId);
      }
      this.$delete(this.warehouse.binList, index);
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.warehouse.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let warehouseObj = {
          id: this.warehouse.id ? this.warehouse.id : "",
          name: this.warehouse.name,
          code: this.warehouse.code,
          location: this.warehouse.location,
          description: this.warehouse.description,
          image: this.warehouse.image,
          imageUrl: this.warehouse.imageUrl,
          type: this.warehouse.type,
          status: this.warehouse.status,
          backInTransfer: this.warehouse.backInTransfer,
          binList: this.warehouse.binList,
          deleteBinIds: this.warehouse.deleteBinIds,
          returnWarehouseId: this.warehouse.backInTransfer
            ? this.warehouse.returnWarehouseId
            : null
        };
        warehouseService
          .saveWarehouse(warehouseObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },

    getWarehousesByStatus() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getWarehouseDetail(id) {
      warehouseService
        .getWarehouseDetail(id)
        .then(res => {
          this.warehouse = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.warehouse.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.warehouse.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          if (this.warehouse.binList) {
            this.warehouse.binList.forEach(element => {
              element.selfExpireDate = commonService.formatDate(
                new Date(element.selfExpireInMilliSeconds)
                  .toISOString()
                  .substr(0, 10),
                "YYYY-MM-DD"
              );
            });
          }
          this.oldWarehouse = JSON.parse(JSON.stringify(this.warehouse));
          this.statusFlag = this.warehouse.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.warehouse.id) {
        this.warehouse = new Warehouse();
        this.statusFlag = true;
        this.addBin();
      } else {
        this.warehouse.binList = [];
        this.warehouse.binList.push(this.warehouse.binList);
        this.warehouse = Object.assign({}, this.oldWarehouse);
        this.statusFlag = this.warehouse.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/warehouses");
    },
    removeImage() {
      this.warehouse.imageUrl = null;
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.warehouse.imageUrl = URL.createObjectURL(file); // to show preview image
      commonService.getBase64(file).then(data => {
        this.warehouse.image = data;
      });
    }
  }
};
</script>
